import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from './Header';
import Footer from './Footer';

function Layout({ children }) {
  const location = useLocation();
  const { user } = useAuth() || {};

  const role = (user?.role || '').toLowerCase();
  const isAdminUser = role === 'admin';

  const pathname = location.pathname || '';
  const isAdminPath = pathname.startsWith('/admin');
  const isAdminDashboard = pathname === '/dashboard' && isAdminUser;

  const hidePublicShell = isAdminPath || isAdminDashboard;

  if (hidePublicShell) {
    return (
      <div style={styles.layout}>
        <main id="main-content" style={styles.main} role="main">
          {children}
        </main>
      </div>
    );
  }

  return (
    <div style={styles.layout}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <header>
        <Header />
      </header>
      <main id="main-content" style={styles.main} role="main">
        {children}
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

const styles = {
  layout: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  main: {
    flex: 1
  }
};

export default Layout;